import { ISound } from "./interfaces/sound.interface";

export class Sound implements ISound {
  constructor(public soundName: string, public path: string) {}
}
